export default __webpack_public_path__ + "static/media/shared-earth-icons-13.8531064b.svg";